import { Modal } from 'semantic-ui-react';
import styled from 'styled-components';
import colors from '../../colors';

const Footer = styled(Modal.Content)`
  border-top: 1px solid ${colors.grey};
`;

export default Footer;
